module.exports = __webpack_public_path__ + "img/tnt.abedbbe2.svg";